
<div>
  <template v-if="usersLoaded">
    <AdminListView lazy :users="users" />
  </template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h4>Användare</h4>
      </b-col>
      <b-col>
        <b-button
          class="float-right"
          size="sm"
          variant="primary"
          @click="createUser"
        >
          Lägg till användare
        </b-button>
      </b-col>
    </b-row>
    <b-table
      fluid
      sticky-header
      striped
      hover
      :items="users"
      :fields="userFields"
    >
      <template #cell(role)="row">
        <template v-if="editing != row.item.id">
          <div
            @click="changeRole(row.item)"
            style="
              word-wrap: break-word;
              min-width: 240px;
              max-width: 240px;
              white-space: normal;
            "
          >
            {{ row.item.role }}
          </div>
        </template>
        <b-form-select
          v-else
          v-model="row.item.role"
          :options="roles"
          @change="onUpdateRole(row.item)"
        />
      </template>
      <template #cell(updated)="row">
        {{ row.item.updated | formatDate }}
      </template>
      <template #cell(reset)="row">
        <b-button
          v-model="row.item.reset"
          type="submit"
          size="sm"
          variant="warning"
          class="mt-0"
          @click="resetUserPassword(row.item)"
        >
          <b-icon-key />
        </b-button>
      </template>
      <template #cell(remove)="row">
        <b-button
          v-model="row.item.remove"
          type="submit"
          size="sm"
          variant="danger"
          class="mt-0"
          @click="deleteUser(row.item)"
        >
          <b-icon-trash />
        </b-button>
      </template>
    </b-table>
  </b-container>
  <CreateUser />
</div>
